import { configureStore } from '@reduxjs/toolkit';

import adminPanelReducer from './adminPanel';
import administration from './administration';
import agGridReducer from './agGrid';
import attributeReducer from './attribute';
import channelReducer from './channel';
import codeChildrenCodebookReducer from './codeChildrenCodebook';
import codeCodebookReducer from './codeCodebook';
import codeCodebookColumnReducer from './codeCodebookColumn';
import codeCodebookColumnValueReducer from './codeCodebookColumnValue';
import codeCodebookTypeReducer from './codeCodebookType';
import codebookTypeGroupReducer from './codebookTypeGroup';
import codebooksForFormReducer from './codebooksForForm';
import compilationReducer from './compilation';
import historyReducer from './history';
import monitoringReducer from './monitoring';
import navigationReducer from './navigation';
import roleReducer from './role';
import securityReducer from './security';
import translationsReducer from './translations';
import userReducer from './user';
import businessPartnerReducer from './businessPartner';

const store = configureStore({
  reducer: {
    loggedUserReducer: securityReducer,
    userReducer,
    roleReducer,
    channelReducer,
    navigationReducer,
    translationsReducer,
    historyReducer,
    adminPanelReducer,
    attributeReducer,
    agGridReducer,
    administrationReducer: administration,
    monitoringReducer,
    codeCodebookTypeReducer,
    codeCodebookReducer,
    codeChildrenCodebookReducer,
    codebooksForFormReducer,
    codeCodebookColumnReducer,
    codeCodebookColumnValueReducer,
    codebookTypeGroupReducer,
    compilationReducer,
    businessPartnerReducer,
  },
});

export default store;
